import { render, staticRenderFns } from "./Register-company-healthcare.vue?vue&type=template&id=ac992344&scoped=true&"
import script from "./Register-company-healthcare.vue?vue&type=script&lang=js&"
export * from "./Register-company-healthcare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac992344",
  null
  
)

export default component.exports